import React from 'react'
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom'
import moment from 'moment'
import Header from './Header'
import Landing from '../components/Landing/Landing.component'
// import ChooseDevice from '../components/ChooseDevice/ChooseDevice.component';
// import { isMobile } from 'react-device-detect'
import Package from '../components/Packages/Package.component'
import Error404 from '../components/Error404/Error404';
import Reservation from '../components/Reservation/Reservation.component'
import Rejoin from '../components/Rejoin/Rejoin.component'
import ErrorByCase from '../components/ErrorByCase/ErrorByCase.component'
import Support from '../components/Support/Support.component'
import Contact from '../components/Contact/Contact.component'
import UserProfile from '../components/UserProfile/UserProfile.component'
import Success from '../components/CancelMemberShip/Success.component'
import Error from '../components/CancelMemberShip/Error.component'
import Referer from '../components/Referer/Referer.component'
import { routersHelper } from '../helpers'
import th from 'moment/locale/th'
import cn from 'moment/locale/zh-cn'
import en from 'moment/locale/es-us'
import PaymentHistory from '../components/PaymentHistory/PaymentHistory.component';
import EditUserProfile from '../components/EditUserProfile/EditUserProfile.component'
import MyRecord from '../components/MyRecord/MyRecord.component'
// import VroomSurvey from '../components/Survey/VroomSurvey'

const RouteView = () => {
    const { useRouter } = routersHelper
    const language = useSelector(state => state.language)
    const router = useRouter()
    const { pathname } = router

    if (language === 'th') {
        moment.updateLocale('th', [th])
    } else if (language === 'cn') {
        moment.updateLocale('zh-cn', [cn])
    } else {
        moment.updateLocale('en', [en])
    }
    return (
        <>
            {
                (
                    pathname !== "/portal/rejoin" &&
                    pathname !== "/portal/error" &&
                    pathname !== "/portal/survey"
                )
                    ? <Header />
                    : <div />
            }
            <Switch>
                {/* <Route exact path="/portal/" component={isMobile ? ChooseDevice : Landing} /> */}
                <Route exact path="/portal/" component={Landing} />
                <Route exact path="/portal/package" component={Package} />
                <Route exact path="/portal/reservation" component={Reservation} />
                <Route exact path="/portal/rejoin" component={Rejoin} />
                <Route exact path="/portal/error" component={ErrorByCase} />
                <Route exact path="/portal/support" component={Support} />
                <Route exact path="/portal/profile" component={UserProfile} />
                <Route exact path="/portal/profile/edit" component={EditUserProfile} />
                <Route exact path="/portal/paymentHistory" component={PaymentHistory} />
                <Route exact path="/portal/successmembership" component={Success} />
                <Route exact path="/portal/errormembership" component={Error} />
                <Route exact path="/portal/contact" component={Contact} />
                <Route exact path="/portal/referrer" component={Referer} />
                <Route exact path="/portal/myrecords" component={MyRecord} />
                {/* <Route exact path="/portal/survey" component={VroomSurvey} /> */}
                <Route exact path="/portal/subscription" element={<Redirect to="/portal" replace />} />
                <Route exact path="/portal/subscription/planspricing" element={<Redirect to="/portal" replace />} />
                <Route component={Error404} />
            </Switch>
            <div />
        </>
    )
}

export default RouteView